import Common from '../../../Common';

const Destination = class extends Common {
	browse = (companyId: id, search: any = {}) =>
		this.get(`/company/${companyId}/callback/destination`, search)

	fromTemplate = (companyId: id) =>
		this.get(`/company/${companyId}/callback/destination/from-template`)
}

export default Destination
